export const fiveLetterWords = new Set([
  'adult',
  'anger',
  'agent',
  'apple',
  'abuse',
  'basis',
  'beach',
  'award',
  'birth',
  'block',
  'board',
  'blood',
  'break',
  'brain',
  'bread',
  'brown',
  'cause',
  'buyer',
  'chain',
  'chair',
  'chief',
  'chest',
  'child',
  'china',
  'class',
  'claim',
  'clock',
  'court',
  'coach',
  'cover',
  'cream',
  'coast',
  'crime',
  'cross',
  'crown',
  'cycle',
  'crowd',
  'death',
  'depth',
  'dance',
  'draft',
  'doubt',
  'drama',
  'dress',
  'drink',
  'dream',
  'drive',
  'enemy',
  'earth',
  'entry',
  'event',
  'error',
  'fault',
  'field',
  'faith',
  'final',
  'floor',
  'focus',
  'frame',
  'fight',
  'frank',
  'fruit',
  'front',
  'force',
  'grass',
  'grant',
  'glass',
  'green',
  'guide',
  'group',
  'henry',
  'horse',
  'hotel',
  'house',
  'heart',
  'index',
  'image',
  'issue',
  'jones',
  'japan',
  'judge',
  'knife',
  'layer',
  'laura',
  'lewis',
  'level',
  'light',
  'major',
  'limit',
  'lunch',
  'match',
  'march',
  'metal',
  'month',
  'model',
  'mouth',
  'money',
  'motor',
  'music',
  'noise',
  'night',
  'novel',
  'north',
  'input',
  'order',
  'nurse',
  'offer',
  'owner',
  'paper',
  'panel',
  'other',
  'party',
  'peace',
  'peter',
  'phone',
  'phase',
  'piece',
  'pitch',
  'pilot',
  'place',
  'plant',
  'plate',
  'plane',
  'point',
  'pound',
  'power',
  'press',
  'pride',
  'proof',
  'prize',
  'price',
  'queen',
  'radio',
  'reply',
  'range',
  'right',
  'river',
  'ratio',
  'round',
  'route',
  'scale',
  'scene',
  'score',
  'scope',
  'sense',
  'shape',
  'share',
  'sheep',
  'sheet',
  'shift',
  'shirt',
  'rugby',
  'sight',
  'simon',
  'shock',
  'sleep',
  'smile',
  'smith',
  'sound',
  'smoke',
  'space',
  'south',
  'speed',
  'spite',
  'squad',
  'skill',
  'sport',
  'staff',
  'stage',
  'start',
  'state',
  'steam',
  'steel',
  'stock',
  'stone',
  'store',
  'study',
  'style',
  'stuff',
  'sugar',
  'taste',
  'theme',
  'terry',
  'table',
  'touch',
  'thing',
  'title',
  'tower',
  'track',
  'total',
  'train',
  'trade',
  'trend',
  'trial',
  'trust',
  'truth',
  'uncle',
  'video',
  'unity',
  'union',
  'visit',
  'value',
  'voice',
  'watch',
  'waste',
  'while',
  'water',
  'woman',
  'youth',
  'whole',
  'admit',
  'world',
  'white',
  'alter',
  'agree',
  'adopt',
  'apply',
  'argue',
  'avoid',
  'begin',
  'arise',
  'break',
  'blame',
  'allow',
  'build',
  'carry',
  'burst',
  'catch',
  'cause',
  'claim',
  'check',
  'clean',
  'clear',
  'climb',
  'close',
  'count',
  'bring',
  'cover',
  'cross',
  'dance',
  'drink',
  'drive',
  'enjoy',
  'exist',
  'enter',
  'doubt',
  'issue',
  'fight',
  'force',
  'imply',
  'focus',
  'guess',
  'laugh',
  'judge',
  'learn',
  'leave',
  'limit',
  'let’s',
  'match',
  'marry',
  'offer',
  'phone',
  'press',
  'order',
  'prove',
  'point',
  'reach',
  'occur',
  'refer',
  'place',
  'serve',
  'raise',
  'relax',
  'share',
  'shift',
  'shoot',
  'shall',
  'speak',
  'sound',
  'solve',
  'sleep',
  'spend',
  'split',
  'start',
  'state',
  'stick',
  'stand',
  'think',
  'study',
  'throw',
  'touch',
  'treat',
  'train',
  'trust',
  'visit',
  'waste',
  'voice',
  'teach',
  'thank',
  'watch',
  'worry',
  'write',
  'alive',
  'acute',
  'alone',
  'would',
  'angry',
  'aware',
  'awful',
  'basic',
  'blind',
  'black',
  'brave',
  'brief',
  'above',
  'broad',
  'civil',
  'brown',
  'clean',
  'cheap',
  'close',
  'clear',
  'crazy',
  'dirty',
  'chief',
  'empty',
  'equal',
  'exact',
  'early',
  'faint',
  'extra',
  'false',
  'fifth',
  'final',
  'fresh',
  'first',
  'front',
  'funny',
  'giant',
  'grand',
  'great',
  'green',
  'gross',
  'daily',
  'harsh',
  'heavy',
  'human',
  'ideal',
  'inner',
  'joint',
  'happy',
  'large',
  'light',
  'local',
  'lucky',
  'loose',
  'magic',
  'major',
  'minor',
  'moral',
  'level',
  'legal',
  'naval',
  'other',
  'plain',
  'outer',
  'prime',
  'naked',
  'quick',
  'prior',
  'nasty',
  'rapid',
  'proud',
  'right',
  'rough',
  'roman',
  'round',
  'royal',
  'sharp',
  'quiet',
  'ready',
  'sheer',
  'sixth',
  'silly',
  'small',
  'smart',
  'rural',
  'sorry',
  'solid',
  'short',
  'still',
  'sweet',
  'super',
  'thick',
  'third',
  'tight',
  'total',
  'tough',
  'upper',
  'usual',
  'spare',
  'steep',
  'upset',
  'vague',
  'vital',
  'white',
  'whole',
  'wrong',
  'afore',
  'valid',
  'young',
  'urban',
  'after',
  'other',
  'bothe',
  'slash',
  'until',
  'where',
  'while',
  'aback',
  'abaft',
  'aboon',
  'about',
  'above',
  'since',
  'adown',
  'afoot',
  'accel',
  'afore',
  'after',
  'again',
  'afoul',
  'agogo',
  'agape',
  'ahull',
  'alife',
  'alike',
  'aline',
  'aloft',
  'alone',
  'along',
  'ahead',
  'agone',
  'aloof',
  'amuck',
  'amiss',
  'apace',
  'apart',
  'aptly',
  'arear',
  'aside',
  'askew',
  'awful',
  'badly',
  'bally',
  'canny',
  'cheap',
  'clean',
  'clear',
  'daily',
  'below',
  'amply',
  'aloud',
  'coyly',
  'dimly',
  'dirty',
  'drily',
  'ditto',
  'dryly',
  'extra',
  'fatly',
  'dully',
  'feyly',
  'first',
  'early',
  'fitly',
  'false',
  'forte',
  'fresh',
  'fully',
  'forth',
  'gaily',
  'gayly',
  'great',
  'haply',
  'godly',
  'heavy',
  'funny',
  'hotly',
  'hence',
  'icily',
  'infra',
  'hella',
  'jildi',
  'jolly',
  'laxly',
  'intl.',
  'lento',
  'light',
  'madly',
  'maybe',
  'lowly',
  'never',
  'nobly',
  'newly',
  'often',
  'other',
  'party',
  'oddly',
  'ought',
  'piano',
  'plumb',
  'prior',
  'plonk',
  'quick',
  'quite',
  'queer',
  'ramen',
  'rapid',
  'right',
  'redly',
  'rough',
  'round',
  'sadly',
  'selly',
  'secus',
  'sharp',
  'sheer',
  'short',
  'shily',
  'plain',
  'since',
  'shyly',
  'silly',
  'sleek',
  'slyly',
  'so-so',
  'small',
  'sound',
  'still',
  'spang',
  'stark',
  'stone',
  'stour',
  'srsly',
  'tally',
  'tanto',
  'thick',
  'there',
  'tight',
  'today',
  'tomoz',
  'super',
  'under',
  'twice',
  'verry',
  'utter',
  'wanly',
  'truly',
  'wetly',
  'wrong',
  'wryly',
  'where',
  'abaft',
  'aboon',
  'adown',
  'above',
  'after',
  'along',
  'afore',
  'among',
  'aloof',
  'cross',
  'circa',
  'below',
  'furth',
  'about',
  'neath',
  'minus',
  'spite',
  'under',
  'until',
  'aargh',
  'round',
  'since',
  'alack',
  'avast',
  'adios',
  'adieu',
  'aloha',
  'bakaw',
  'begad',
  'basta',
  'blige',
  'bless',
  'bravo',
  'bring',
  'damme',
  'brava',
  'dildo',
  'ditto',
  'chook',
  'frick',
  'fudge',
  'hallo',
  'golly',
  'hasta',
  'gratz',
  'havoc',
  'hello',
  'howay',
  'howdy',
  'hullo',
  'huzza',
  'jesus',
  'kapow',
  'loose',
  'hella',
  'mercy',
  'night',
  'lordy',
  'plonk',
  'marry',
  'quite',
  'psych',
  'salve',
  'there',
  'sooey',
  'sniff',
  'thiam',
  'skoal',
  'thwap',
  'twirp',
  'tough',
  'vivat',
  'viola',
  'wahey',
  'wilma',
  'wirra',
  'woops',
  'wowie',
  'whist',
  'yeeha',
  'yecch',
  'yeesh',
  'wacko',
  'yowch',
  'zowie',
]);

export const sixLetterWords = new Set([
  'Abroad',
  'Casual',
  'Around',
  'Couple',
  'Accept',
  'Caught',
  'Arrive',
  'Course',
  'Access',
  'Center',
  'Artist',
  'Covers',
  'Across',
  'Centre',
  'Aspect',
  'Create',
  'Acting',
  'Chance',
  'Assess',
  'Credit',
  'Action',
  'Change',
  'Assist',
  'Crisis',
  'Active',
  'Charge',
  'Assume',
  'Custom',
  'Actual',
  'Choice',
  'Attack',
  'Damage',
  'Advice',
  'Choose',
  'Attend',
  'Danger',
  'Advise',
  'Chosen',
  'August',
  'Dealer',
  'Affect',
  'Church',
  'Author',
  'Debate',
  'Afford',
  'Circle',
  'Avenue',
  'Decade',
  'Afraid',
  'Client',
  'Backed',
  'Decide',
  'Agency',
  'Closed',
  'Barely',
  'Defeat',
  'Agenda',
  'Closer',
  'Battle',
  'Defend',
  'Almost',
  'Coffee',
  'Beauty',
  'Define',
  'Always',
  'Column',
  'Became',
  'Degree',
  'Amount',
  'Combat',
  'Become',
  'Demand',
  'Animal',
  'Coming',
  'Before',
  'Depend',
  'Annual',
  'Common',
  'Behalf',
  'Deputy',
  'Answer',
  'Comply',
  'Behind',
  'Desert',
  'Anyone',
  'Copper',
  'Belief',
  'Design',
  'Anyway',
  'Corner',
  'Belong',
  'Desire',
  'Appeal',
  'Costly',
  'Bestie',
  'Detail',
  'Appear',
  'County',
  'Better',
  'Detect',
  'Beyond',
  'Budget',
  'During',
  'Device',
  'Bishop',
  'Burden',
  'Easily',
  'Differ',
  'Border',
  'Bureau',
  'Eating',
  'Dinner',
  'Bottle',
  'Button',
  'Editor',
  'Direct',
  'Bottom',
  'Camera',
  'Effect',
  'Doctor',
  'Bought',
  'Cancer',
  'Effort',
  'Dollar',
  'Branch',
  'Cannot',
  'Eighth',
  'Domain',
  'Breath',
  'Carbon',
  'Either',
  'Double',
  'Bridge',
  'Career',
  'Eleven',
  'Driven',
  'Bright',
  'Castle',
  'Emerge',
  'Driver',
]);
export const sevenLetterWords = new Set([
  'abandon',
  'ability',
  'absence',
  'academy',
  'account',
  'accused',
  'airline',
  'airport',
  'alcohol',
  'alleged',
  'already',
  'alright',
  'amateur',
  'amnesty',
  'amusing',
  'analogy',
  'analyst',
  'analyze',
  'backing',
  'backlog',
  'baggage',
  'balance',
  'balcony',
  'balloon',
  'bangkok',
  'banking',
  'banquet',
  'bargain',
  'barrier',
  'baseman',
  'besides',
  'between',
  'bicycle',
  'bidding',
  'billing',
  'billion',
  'binding',
  'biology',
  'bizarre',
  'brewery',
  'brigade',
  'broaden',
  'brother',
  'brought',
  'brushed',
  'buffalo',
  'builder',
  'bullpen',
  'burning',
  'butcher',
  'buyback',
  'cabinet',
  'chapter',
  'charity',
  'charlie',
  'charter',
  'chassis',
  'checked',
  'chemist',
  'chicken',
  'cluster',
  'coating',
  'cocaine',
  'cockpit',
  'collect',
  'college',
  'collins',
  'colonel',
  'combine',
  'comfort',
  'command',
  'comment',
  'compact',
  'convert',
  'coroner',
  'courier',
  'cracked',
  'creator',
  'cricket',
  'crowded',
  'deserve',
  'desktop',
  'despair',
  'despite',
  'destiny',
  'diocese',
  'dioxide',
  'diploma',
  'discuss',
  'disease',
  'dislike',
  'dismiss',
  'display',
  'dispose',
  'dispute',
  'drought',
  'dubious',
  'durable',
  'dynamic',
  'earnest',
  'embassy',
  'embrace',
  'eminent',
  'emotion',
  'emperor',
  'empower',
  'ethanol',
  'excited',
  'exclude',
  'execute',
  'exhaust',
  'exhibit',
  'expense',
  'explain',
  'exploit',
  'explore',
  'express',
  'extract',
  'fashion',
  'fatigue',
  'favored',
  'fearful',
  'figured',
  'filling',
  'finance',
  'finding',
  'firstly',
  'fishing',
  'fitness',
  'fitting',
  'forward',
  'founder',
  'foundry',
  'fragile',
  'frankly',
  'freedom',
  'freeman',
  'freight',
  'fucking',
  'general',
  'generic',
  'genesis',
  'genetic',
  'genuine',
  'geology',
  'gesture',
  'gigabit',
  'gilbert',
  'glimpse',
  'glucose',
  'goodbye',
  'greater',
  'griffin',
  'grocery',
  'guarded',
  'habitat',
  'halfway',
  'handful',
  'hanging',
  'harbour',
  'harmful',
  'helpful',
  'helping',
  'herring',
  'herself',
  'highway',
  'himself',
  'history',
  'holding',
  'holiday',
  'holland',
  'honesty',
  'hopeful',
  'hygiene',
  'ideally',
  'illegal',
  'illness',
  'imagery',
  'imagine',
  'imaging',
  'immense',
  'impetus',
  'impress',
  'improve',
  'impulse',
  'include',
  'initial',
  'inquiry',
  'insider',
  'insight',
  'inspect',
  'inspire',
  'install',
  'instant',
  'instead',
  'insulin',
  'insured',
  'insurer',
  'isolate',
  'jealous',
  'jointly',
  'journey',
  'justice',
  'justify',
  'keeping',
  'keynote',
  'keyword',
  'kickoff',
  'killing',
  'landing',
  'largely',
  'lasting',
  'lateral',
  'laundry',
  'lawsuit',
  'leading',
  'leaning',
]);
